import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {TodoDb} from './todoDbSchema';
import {Todo, todoSchema} from './todoSchema';

export function mapTodoDbToType(db: FirestoreDocSnapshotWithIdAndData<TodoDb>): Todo {
  const data = mapFirestoreDocWithTimestamp(db);
  return todoSchema.parse(data);
}
